<div class="modal-content">
  <div class="modal-header">
    <div class="header col-xs-9">Upload Images</div>
    <div class="closebt col-xs-2" data-dismiss="modal" aria-label="Close" (click)="onClose()">×</div>
  </div>

  <div class="modal-body">
    @if (imgUploadarea) {
      <div class="uploadsection">
        <div class="qrbox" >
          <div class="scantext"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M17 2H7C5.89543 2 5 2.89543 5 4V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V4C19 2.89543 18.1046 2 17 2Z" stroke="#2A3237" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 18H12.01" stroke="#2A3237" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
            </svg> <span>Scan with Mobile</span></div>
            <qr-code [value]=qrurl [size]="256" [errorCorrectionLevel]="'M'"></qr-code>
            <div class="qrtext">Scan this QR code with your phone camera to upload photos directly from your mobile device</div>
          </div>
          <div class="middleor" >or</div>
          <div class="drop-area" >
            <div class="drag-form">
              <div class="dragiconsection">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 3V15M12 3L17 8M12 3L7 8M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="#5D6F7B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <p><b>Drag & Drop an image to upload</b></p>
              <ngx-file-drop (onFileDrop)="onFileDrop($event)" [showBrowseBtn]="true" browseBtnLabel="Browse Files" [multiple]="true">
              </ngx-file-drop>
            </div>
          </div>
        </div>
      }
      @if (imgGalleryarea) {
        <div class="carousel-area">
          @if (selectedImage) {
            <div class="selected-image-container">
              <i class="fa-solid fa-chevron-left" (click)="previousImage()"></i>
              <div class="image-wrapper">
                <img [src]="selectedImage.src" class="selected-image" [class.slide-left]="slideLeft" [class.slide-right]="slideRight">
              </div>
              <i class="fa-solid fa-chevron-right" (click)="nextImage()"></i>
            </div>
          }
        </div>
      }
      @if (imgGalleryarea) {
        <div class="imgname_remove">
          <div class="imgname_removeflex">
            <div class="imgname">{{ selectedImage?.name }}</div>
            <!--         <div class="removebtn" (click)="removeSelectedImage()">{{"returnsUK.removelabel" | cxTranslate}}</div>
          -->      </div>
        </div>
      }
      <div class="gallery" >
        <div class="gallery_container">
          <div class="gallery_leftarea" >
            <div class="imagecontainer">
              @if (thumbImgarea) {
                <div gallerize>
                  @for (img of locationImages; track img; let i = $index) {
                    <div class="gallery-item">
                      <img [src]="img.src" (click)="selectImage(i)" [class.selected]="i === selectedIndex">
                      <div class="deleteicon" (click)="removeSelectedImage(i)"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
                        <g clip-path="url(#clip0_7083_2687)">
                          <path d="M6.54545 16.25V7.08333C6.54545 6.96181 6.5071 6.86198 6.4304 6.78385C6.35369 6.70573 6.25568 6.66667 6.13636 6.66667H5.31818C5.19886 6.66667 5.10085 6.70573 5.02415 6.78385C4.94744 6.86198 4.90909 6.96181 4.90909 7.08333V16.25C4.90909 16.3715 4.94744 16.4714 5.02415 16.5495C5.10085 16.6276 5.19886 16.6667 5.31818 16.6667H6.13636C6.25568 16.6667 6.35369 16.6276 6.4304 16.5495C6.5071 16.4714 6.54545 16.3715 6.54545 16.25ZM9.81818 16.25V7.08333C9.81818 6.96181 9.77983 6.86198 9.70312 6.78385C9.62642 6.70573 9.52841 6.66667 9.40909 6.66667H8.59091C8.47159 6.66667 8.37358 6.70573 8.29688 6.78385C8.22017 6.86198 8.18182 6.96181 8.18182 7.08333V16.25C8.18182 16.3715 8.22017 16.4714 8.29688 16.5495C8.37358 16.6276 8.47159 16.6667 8.59091 16.6667H9.40909C9.52841 16.6667 9.62642 16.6276 9.70312 16.5495C9.77983 16.4714 9.81818 16.3715 9.81818 16.25ZM13.0909 16.25V7.08333C13.0909 6.96181 13.0526 6.86198 12.9759 6.78385C12.8991 6.70573 12.8011 6.66667 12.6818 6.66667H11.8636C11.7443 6.66667 11.6463 6.70573 11.5696 6.78385C11.4929 6.86198 11.4545 6.96181 11.4545 7.08333V16.25C11.4545 16.3715 11.4929 16.4714 11.5696 16.5495C11.6463 16.6276 11.7443 16.6667 11.8636 16.6667H12.6818C12.8011 16.6667 12.8991 16.6276 12.9759 16.5495C13.0526 16.4714 13.0909 16.3715 13.0909 16.25ZM6.13636 3.33333H11.8636L11.25 1.8099C11.1903 1.73177 11.1179 1.68403 11.0327 1.66667H6.98011C6.89489 1.68403 6.82244 1.73177 6.76278 1.8099L6.13636 3.33333ZM18 3.75V4.58333C18 4.70486 17.9616 4.80469 17.8849 4.88281C17.8082 4.96094 17.7102 5 17.5909 5H16.3636V17.3438C16.3636 18.0642 16.1634 18.6871 15.7628 19.2122C15.3622 19.7374 14.8807 20 14.3182 20H3.68182C3.11932 20 2.63778 19.7461 2.23722 19.2383C1.83665 18.7305 1.63636 18.1163 1.63636 17.3958V5H0.409091C0.289773 5 0.191761 4.96094 0.115057 4.88281C0.0383523 4.80469 0 4.70486 0 4.58333V3.75C0 3.62847 0.0383523 3.52865 0.115057 3.45052C0.191761 3.3724 0.289773 3.33333 0.409091 3.33333H4.35938L5.25426 1.15885C5.3821 0.837674 5.61222 0.564236 5.9446 0.338542C6.27699 0.112847 6.61364 0 6.95455 0H11.0455C11.3864 0 11.723 0.112847 12.0554 0.338542C12.3878 0.564236 12.6179 0.837674 12.7457 1.15885L13.6406 3.33333H17.5909C17.7102 3.33333 17.8082 3.3724 17.8849 3.45052C17.9616 3.52865 18 3.62847 18 3.75Z" fill="white"/>
                        </g>
                        <defs>
                          <clipPath id="clip0_7083_2687">
                            <rect width="18" height="20" fill="white"/>
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
        <div class="gallery_rightarea" >
          <div class="submitcancelsection">
            @if (imgGalleryarea) {
              <div class="uploadmorebtn" (click)="uploadMore()">{{"returnsUK.uploadmore" | cxTranslate}}</div>
            }
            <div class="donebtn" id="donebtn-60149134" data-dismiss="modal" aria-label="Close" (click)="onClose()">{{"returnsUK.donelabel" | cxTranslate}}</div>
          </div>
        </div>
        <div class="uploadjobbagcode">{{ uploadjobbagcode?.jobBagCode }}</div>
      </div>
    </div>

  </div>

</div>

